import axios from '@/libs/api.request'
export const getConfig = async (that, data) => {
    var res = await axios.request({
        url: '/app/api/getConfig',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
        if (res.code == -2) {
            that.handleLogOut();
            that.$router.push({
                name: 'login'
            })
        }
    }
    return res;
}
export const sendSms = async (that, data) => {
    var res = await axios.request({
        url: '/app/api/getSmsCode',
        data,
        method: 'post'
    })
    res = res.data;
    if (res.code != 1) {
        that.$Message.error(res.msg);
    }
    return res;
}

